"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectedTabBackgroundColor = exports.isContained = exports.USES = void 0;

var _TabConstants = require("../TabConstants");

var USES = ['default', 'enclosed', 'enclosed-shaded', 'flush', 'header', 'toolbar'];
exports.USES = USES;

var isContained = function isContained(use) {
  return use === 'enclosed' || use === 'enclosed-shaded' || use === 'flush' || use === 'toolbar';
};

exports.isContained = isContained;

var getSelectedTabBackgroundColor = function getSelectedTabBackgroundColor(use) {
  return use === 'enclosed-shaded' ? _TabConstants.ENCLOSED_SHADED_SELECTED_BACKGROUND_COLOR : _TabConstants.ENCLOSED_SELECTED_BACKGROUND_COLOR;
};

exports.getSelectedTabBackgroundColor = getSelectedTabBackgroundColor;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/nav/utils/tabUtils.js
// module id = 388
// module chunks = 209 210 211 212